import React, { useEffect, useState } from "react";
import moment from "moment";
import { Constants } from "../../CommonMethhods/Constants";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Sidebar from "../../Components/Sidebar";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkDateRange,
  compareDate,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import FromdateComponent from "./FromdateComponent";
import TodateComponent from "./TodateComponent";
import Loader from "../../Components/Common/Loader";
import RevenueTable from "../../Components/ReportTables/RevenueTable";
import { toast } from "react-toastify";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { useDebounce } from "../../Components/useDebounce";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import RevenueTableNew from "../../Components/ReportTables/RevenueTableNew";
import DurationChangeComponent from "./DurationChangeComponent";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function RevenueReport() {
  const storeToken = localStorage.getItem("ssoToken");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [gridVal, setGridVal] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [checkDate, setCheckDate] = useState(false);
  const [count, setCount] = useState();
  const [clientCode, setClientCode] = useState("");
  const [error, setError] = useState(false);
  const [DateErrorResp, setDateErrorResp] = useState("");
  const [serverError, setServerError] = useState("");
  const [show, setShow] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [totalValue, setTotalValue] = useState();
  const [customShow, setCustomShow] = useState(false)
  const [selectDuration, setSelectDuration] = useState("");
  const [seg, setSeg] = useState("");
  const [zoneList, setZoneList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");


  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    setLoader(true);
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  if (fromDate === "" || toDate === "") {
    const current = new Date();
    const CurrentYear = current.getFullYear();
    const CurrentMonth = current.getMonth();

    const newYear = moment(current).format("MM-DD-YYYY");
    const date = `${current.getMonth() + 1
      }-${current.getDate()}-${current.getFullYear()}`;
    const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    setFromDate(newYear);
    setToDate(date1);
  }

  function formatDate(date) {
    return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
  }

  const currentDate = new Date();
  const yyyy = currentDate.getFullYear();
  let mm = currentDate.getMonth() + 1;
  let dd = currentDate.getDate();
  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const FormatedDate = dd + "/" + mm + "/" + yyyy;
  const DateReverse = FormatedDate.split("/").reverse().join("-");

  const handleFromDateChange = (e) => {
    document.querySelector("#SearchInput_RevenueReport").value = "";
    setGridVal([]);
    // setClientCode("");
    setError(false);
    // setFileType("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setFromDate(d);
    setDateErrorResp("");
    setServerError("");
  };
  const handleToDateChange = (e) => {
    document.querySelector("#SearchInput_RevenueReport").value = "";
    setGridVal([]);
    // setClientCode("");
    setError(false);
    // setFileType("");
    let c = e.target.value;
    const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
    setToDate(d);
    setDateErrorResp("");
    setServerError("");
  };

  const getRevenueReport = async (fileType, mainLoader = false) => {
    let clientCo = document.querySelector("#SearchInput_RevenueReport").value;

    if (fileType === "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
    }
    if (fileType === "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
    }
    if (mainLoader) {
      setSmallLoaderExcel(false);
      setLoader(true);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCo,
      fromDate: fromDate,
      toDate: toDate,
      fileType: fileType,
      branch: selectedBranch,
      region: selectedRegion,
      zone: selectedZone,
    };
    let encPayload = AESEncryption(payloadValue);
    console.log("payload", payloadValue)
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Revenue_Report_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      console.log(res, "resRevenue");
      

      if (res?.status === 0) {
        setError(false);
        if (fileType === "grid") {
          setTotalValue(res?.data);
          setCount(res?.data?.totalCount);
          setGridVal(res?.data?.revenueList);
          //   if (pageNo > 1) {
          //     setGridVal((prev) => {
          //       return [...prev, ...res?.revenueClients];
          //     });
          //   } else {
          //     setGridVal(res?.revenueClients);
          //   }
        } else if (fileType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        setGridVal([]);
        if (fileType === "excel") {
          toast.error("Revenue Report does not exist.");
        } else if (fileType === "pdf") {
          toast.error("Revenue Report does not exist.");
        } else {
          setError(res?.message);
          setShow(false);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError("Something went wrong, Please try again later.");
      if (fileType === "excel") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (fileType === "pdf") {
        toast.error("Something went wrong, Please try again later.");
      }
      if (clientCode !== "" && fileType === "grid") {
        toast.error("Something went wrong, Please try again later.");
        setClientCode("");
      }
    } finally {
      setLoader(false);
      setSearchLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setScrollLoader(false);
    }
  };

  const handleOnClick = (e) => {
    if (fromDate.length > 0 && toDate.length > 0) {
      if (
        compareDate(fromDate) &&
        compareDate(toDate) &&
        checkDateRange(fromDate, toDate)
      ) {
        if (e.target.value === "grid") {
          document.querySelector("#SearchInput_RevenueReport").value = "";
          getRevenueReport("grid", true);
          document.querySelector("#SearchInput_RevenueReport").value = "";
          setClientCode("");
          setDateErrorResp("");
        } else {
          if (e.target.value === "pdf") {
            getRevenueReport("pdf", false);
          } else if (e.target.value === "excel") {
            getRevenueReport("excel", false);
          }
        }
      } else {
        setCheckDate(true);

        setDateErrorResp("Please Select Correct Date");
      }
    }
    // setPage(1);
  };

  const handleZone = (e) => {
    const zone = e.target.value;
    setGridVal([]);
    setSelectedZone(zone);
    setSelectedRegion("");
    setSelectedBranch("");
    setBranchList([]);
    setRegionList([]);

    if (zone === "") {
      getRegion("");
      getBranch("");
    }
  };

  const handleRegion = (e) => {
    const region = e.target.value;
    setGridVal([]);
    setSelectedRegion(region);
    setSelectedBranch("");
    setBranchList([]);
    if (region === "") {
      getBranch("");
    }
  };

  const handleBranch = (e) => {
    setGridVal([]);
    setSelectedBranch(e?.target?.value);
  }

  const getZone = async () => {

    try {
      const getDetails = await axiosInstance.get(
        Dashboard_Client_Report.Get_Zone,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setZoneList(res?.data);
      } else {
        toast.error(res?.message);
        setZoneList([]);
      }
    } catch (error) {
      console.log(error);
      setZoneList([]);
    }
  };

  const getRegion = async (zone = "") => {

    let payloadValue = {
      zone: zone
    }
    console.log(payloadValue, "payloadZone");

    let encPayload = AESEncryption(payloadValue);

    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Get_Region,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setRegionList(res?.data || []);
      } else {
        toast.error(res?.message);
        setRegionList([]);
      }
    } catch (error) {
      console.log(error);
      setRegionList([]);
    }
  };

  const getBranch = async (region = "") => {
    let payloadValue = {
      region: region
    }
    console.log(payloadValue, "payloadBranch");

    let encPayload = AESEncryption(payloadValue);

    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.Get_Branch,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {
        setBranchList(res?.data || []);
      } else {
        toast.error(res?.message);
        setBranchList([]);
      }
    } catch (error) {
      console.log(error);
      setBranchList([]);
    }
  };

  useEffect(() => {
    getZone();
    getRegion("");
    getBranch("");
  }, []);

  useEffect(() => {
    if (selectedZone) {
      getRegion(selectedZone);
    }
  }, [selectedZone]);

  useEffect(() => {
    if (selectedRegion) {
      getBranch(selectedRegion);
    }
  }, [selectedRegion]);

  function handleClientName(data) {
    setGridVal([]);
    setError(false);
    setSearchLoader(true);
    getRevenueReport("grid", data === "", data);
  }
  const onChangeDuration = () => {
    setGridVal([]);
    setError(false);
    setServerError(false);
  }
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box revenue-report revenue-report-wrapper">
          <div className="figure-inlac">
            <h2 className="report-title">Revenue Report</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          </div>
          <div className="row input-field-wrapper">
            <div
              className="col-md-3 col-sm-3 col-6"
            // onBlur={(e) => {
            //   handleBlurRevenue(e);
            // }}
            >
              <div className="form-group">
                <label className="form-label">{Constants.Client_Search}</label>

                <div className="rm-custom-dropdown">
                  <input
                    type="text"
                    name="search-text"
                    id="SearchInput_RevenueReport"
                    className="input-st"
                    placeholder="Search here..."
                    autoComplete="off"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e.target.value.toUpperCase());
                      setShow(true);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                        .toUpperCase()
                        .replace(/[^A-Z0-9\s]/g, "")
                        .replace(/\s+/g, " ")
                        .trimStart()
                        .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                    }}
                  />
                  <button
                    className="rm-dropdown-btn"
                    onClick={() => setShow(!show)}
                  >
                    <span className="icon-right-arrow-triangle"></span>
                  </button>
                  {show && (
                    <>
                      <ul
                        className="rm-mapping-ap border-0"
                      // onScroll={(e) => handleScrollUl(e)}
                      >
                        {/* {checkResp.lenght > 0 ? ( */}
                        {gridVal &&
                          gridVal.map((item, i) => (
                            <li
                              key={i}
                              className="rm-maping-item-wrapper"
                              onClick={() => {
                                setShow(false);
                                document.querySelector(
                                  "#SearchInput_RevenueReport"
                                ).value = item?.partyCode;
                                setClientCode(item?.partyCode);
                                // setLoader(true);
                              }}
                            >
                              <div> {item?.clientName}</div>
                              <div> {item?.partyCode}</div>
                            </li>
                          ))}
                        {searchLoader && !loader && (
                          <div className="loader-center">
                            <LoaderForSearch />
                          </div>
                        )}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <DurationChangeComponent
                  setCustomShow={setCustomShow}
                  setFromDate={setFromDate}
                  setToDate={setToDate}
                  onChangeDuration={onChangeDuration}
                  selectDuration={selectDuration}
                  setSelectDuration={setSelectDuration}
                />
              </div>
            </div>
            {customShow && <div className="col-md-3 col-sm-4 col-12">
              <FromdateComponent
                fromDate={handleFromDateChange}
                formatDate={formatDate(fromDate)}
                DateReverse={DateReverse}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}
            {customShow && <div className="col-md-3 col-sm-4 col-12">
              <TodateComponent
                toDate={handleToDateChange}
                formatToDate={formatDate(toDate)}
                DateReverse={DateReverse}
                errorResponse={DateErrorResp}
                clientWiseReportForCustomCalanderIcon={true}
              />
            </div>}

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Zone:</label>
                <select value={selectedZone} onChange={handleZone}>
                  <option value="">Select Zone</option>
                  {zoneList?.map((data, index) => (
                    <option key={index} value={data}>{data}</option>
                  ))}


                </select>
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Region:</label>
                <select value={selectedRegion} onChange={handleRegion}>
                  <option value="">Select Region</option>
                  {regionList?.map((data, index) => (
                    <option key={index} value={data}>{data}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Branch:</label>
                <select value={selectedBranch} onChange={handleBranch}>
                  <option value="">Select Branch</option>
                  {branchList?.map((data, index) => (
                    <option key={index} value={data}>{data}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {/* <div className="row d-flex justify-content-between"> */}

          <div>
            <ReportTableHeader
              showEmailBtn={false}
              handleOnClick={handleOnClick}
              smallLoaderExcel={smallLoaderExcel}
              smallLoaderPdf={smallLoaderPdf}
            />
            {/* </div> */}
          </div>

          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
            >
              {Constants.Search}
            </button>
          </div>
          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : gridVal && gridVal.length > 0 ? (
              <>
                <div>
                  <RevenueTableNew
                    error={error}
                    gridVal={gridVal}
                    scrollLoader={scrollLoader}
                    totalValue={totalValue}
                  />
                </div>
              </>
            ) : error ? (
              <h4 className="report-error-message">{noDataFound(error)}</h4>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default RevenueReport;
